<template>
  <div>
    <label v-if="labelText" :for="id" class="custom_input_label">
      {{ labelText }}
    </label>
    <validation-provider
      v-slot="{ errors }"
      :name="name || label"
      :rules="rules"
    >
      <v-textarea
        :id="id"
        v-bind="$attrs"
        :error-messages="errors[0]"
        :label="label"
        :value="value"
        name="input-7-4"
        v-on="{ ...$listeners, input: () => {} }"
        solo
        @input="(val) => $emit('input', val)"
      ></v-textarea>
    </validation-provider>
  </div>
</template>

<script>
import { generateText } from "@/utils/pureFunctions";

export default {
  name: "CustomTextTextarea",
  props: {
    value: {},
    rules: {},
    name: {
      type: String,
    },
    labelText: {
      type: String,
    },
    textarea: {
      type: String,
    },
    label: {
      type: String,
    },
  },
  created() {
    this.id = generateText(10);
  },
};
</script>

<style scoped></style>
